<div class="flex justify-center align-middle items-center">
  <div class="flex flex-col p-5 md:p-6 mb-3 md:mb-8 rounded-m bg-neutral-100 text-center">
    <p class="text-md md:text-29px font-accent font-bold text-neutral-800">
      {{ error | translate }}
    </p>
  </div>
</div>
<div
  *ngIf="displayRetryButton"
  class="w-full flex justify-center pt-10"
>
  <app-button-atom
    class="mx-auto"
    [disabled]="isLoading"
    [icon]="isLoading ? undefined : 'icon-repeat-circle'"
    [iconUrl]="isLoading ? 'assets/images/spinner.svg' : undefined"
    [label]="'pay-at-table.error.retry' | translate"
    [size]="'M'"
    (click)="retry()"
  ></app-button-atom>
</div>
